/* eslint-disable no-template-curly-in-string */
import PlayListRemove from 'assets/icons/PlayListRemove';
import { EtapaProjeto, indexOfEtapa } from 'models/projeto';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import RefreshIcon from '../../components/Icons/RefreshIcon';
import {
  PROJECT_STATUS_APROVADO,
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
  PROJECT_STATUS_REJEITADO,
} from '../../library/ProjectStatus';
import { getStepSlug } from '../../library/ProjectSteps';
import { baseProjectPathWithId } from '../../library/Routes';
import {
  changeModalProps,
  closeModal,
  openModal,
} from '../../store/modules/ModalActions';
import {
  ativarProjeto,
  desativarProjeto,
  removerProjeto,
} from '../../store/modules/ProjetoActions';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import { isGeneratingPdfById } from '../../utils/ProjetoUtils';
import { Col } from '../Col';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import CoordenadorCheck from '../CoordenadorCheck/CoordenadorCheck';
import DownloadProjeto from '../DownloadProjeto/DownloadProjeto';
import DeleteForeverIcon from '../Icons/DeleteForeverIcon';
import MoreVert from '../Icons/MoreVertIcon';
import NoChecks from '../NoChecks/NoChecks';
import ProfessorGestorCheck from '../ProfessorGestorCheck/ProfessorGestorCheck';
import ProjectStepsMenu from '../ProjectStepsMenu/ProjectStepsMenu';
import { Row } from '../Row';
import TooltipCaller from '../TooltipManager/TooltipCaller';
import styles from './ProjetoItem.scss';
import StatusIcon from './StatusIcon';
import PlayListAdd from 'assets/icons/PlayListAdd';
import DoubleChecked from 'components/DoubleCheck/DoubleChecked';

const rootClassName = styles.rootClassName;

class ProjetoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpened: false,
      menuAnchor: null,
      modalKey: null,
      generatePdf: false,
      removing: false,
    };

    this.toOpenMenu = this.toOpenMenu.bind(this);
    this.toCloseMenu = this.toCloseMenu.bind(this);
  }

  getEtapaByIndex(stepIndex) {
    switch (stepIndex) {
      case 0:
        return this.props.languageValues.preCadastro;
      case 1:
        return this.props.languageValues.etapa1;
      case 2:
        return this.props.languageValues.etapa2_1;
      case 3:
        return this.props.languageValues.etapa2_2;
      case 4:
        return this.props.languageValues.etapa3;
      case 5:
        return this.props.languageValues.etapa4;
      case 6:
        return this.props.languageValues.etapa5;
      case 7:
        return this.props.languageValues.etapa6;
      case 8:
        return this.props.languageValues.etapa7;
      case 9:
        return this.props.languageValues.etapa8;
      case 10:
      default:
        return this.props.languageValues.etapa9;
    }
  }

  getStatusHint(status) {
    switch (status) {
      case PROJECT_STATUS_RASCUNHO:
        return this.props.languageValues.projectRascunhoStatusButtonHint;
      case PROJECT_STATUS_PENDENTE:
        return this.props.languageValues.projectPendenteStatusButtonHint;
      case PROJECT_STATUS_APROVADO:
        return this.props.languageValues.projectAprovadoStatusButtonHint;
      case PROJECT_STATUS_REJEITADO:
        return this.props.languageValues.projectRejeitadoStatusButtonHint;
      default:
        return '';
    }
  }

  getCroppedAvaliacoes() {
    return this.props.projeto.flgNovoTemplate
      ? this.props.projeto.avaliacoes.slice(
        0,
        indexOfEtapa(EtapaProjeto.revisao)
      )
      : this.props.projeto.avaliacoes.slice(0, 10);
  }

  isTotalApproved() {
    const croppedAvaliacoes = this.getCroppedAvaliacoes();
    return (
      !croppedAvaliacoes.includes(PROJECT_STATUS_RASCUNHO) &&
      !croppedAvaliacoes.includes(PROJECT_STATUS_PENDENTE) &&
      !croppedAvaliacoes.includes(PROJECT_STATUS_REJEITADO)
    );
  }

  getAllUniqueStatus() {
    let allStatus = [];
    let croppedAvaliacoes = this.getCroppedAvaliacoes();
    if (croppedAvaliacoes.indexOf(PROJECT_STATUS_RASCUNHO) > -1) {
      allStatus.push(PROJECT_STATUS_RASCUNHO);
    }
    if (croppedAvaliacoes.indexOf(PROJECT_STATUS_PENDENTE) > -1) {
      allStatus.push(PROJECT_STATUS_PENDENTE);
    }
    if (croppedAvaliacoes.indexOf(PROJECT_STATUS_REJEITADO) > -1) {
      allStatus.push(PROJECT_STATUS_REJEITADO);
    }
    if (
      allStatus.length === 0 &&
      croppedAvaliacoes.indexOf(PROJECT_STATUS_APROVADO) > -1
    ) {
      allStatus.push(PROJECT_STATUS_APROVADO);
    }
    return allStatus;
  }

  toOpenMenu(event) {
    this.setState({
      ...this.state,
      menuOpened: true,
      menuAnchor: event.currentTarget,
    });
  }

  toCloseMenu() {
    this.setState({
      ...this.state,
      menuOpened: false,
    });
  }

  confirmAtivarDesativarProjeto = () => {
    this.props.openModal(ConfirmModal, {
      title: this.props.projeto.flgAtivo
        ? this.props.languageValues.desativarProjetoTitle
        : this.props.languageValues.ativarProjetoTitle,
      content: this.props.projeto.flgAtivo
        ? this.props.languageValues.desativarProjetoContent
        : this.props.languageValues.ativarProjetoContent,
      confirmLabel: this.props.languageValues.confirmModalConfirmButtonSim,
      confirmCallback: this.handleAtivarDesativarProjeto,
    });
  };

  projetoChecked() {
    if (
      !this.props.projeto.checkCoordenador &&
      !this.props.projeto.checkProfGestor
    ) {
      return (
        <TooltipCaller text={this.props.languageValues.noChecksTooltip}>
          <NoChecks className={`${rootClassName}-status-button`} />
        </TooltipCaller>
      );
    }

    if (
      this.props.projeto.checkCoordenador &&
      this.props.projeto.checkProfGestor
    ) {
      return (
        <TooltipCaller text={this.props.languageValues.doubleCheckTooltip}>
          <DoubleChecked />
        </TooltipCaller>
      );
    }

    if (
      !this.props.projeto.checkCoordenador &&
      this.props.projeto.checkProfGestor
    ) {
      return (
        <TooltipCaller
          text={this.props.languageValues.professorGestorCheckTooltip}
        >
          <ProfessorGestorCheck />
        </TooltipCaller>
      );
    }

    if (
      this.props.projeto.checkCoordenador &&
      !this.props.projeto.checkProfGestor
    ) {
      return (
        <TooltipCaller text={this.props.languageValues.coordenadorCheckTooltip}>
          <CoordenadorCheck />
        </TooltipCaller>
      );
    }
  }

  isDisabled = () => {
    return isGeneratingPdfById(this.props.projetos.generatingPdfById, this.props.projeto.id) ||
      this.state.removing ||
      !this.props.projeto.flgAtivo;
  };

  openProjectNewPage = () => {
    if (
      this.props.auth.userPermissions.projetos.edit ||
      this.props.auth.userPermissions.projetos.approve ||
      this.props.auth.userPermissions.projetos.reprove
    ) {
      const isMobileView = window.innerWidth <= 768;
      const isDesktopView = !isMobileView;
      let url = '';

      if (this.props.projeto.flgNovoTemplate) {
        url = `${baseProjectPathWithId
          .replace(':id', this.props.projeto.id)
          .replace(':stepSlugName', EtapaProjeto.revisao)}`;
      } else {
        url = `${baseProjectPathWithId
          .replace(':id', this.props.projeto.id)
          .replace(':stepSlugName', getStepSlug(10))}`;
      }

      if (isDesktopView) {
        window.open(url, '_blank');
      } else {
        this.props.history.push(url);
      }
    }
  };

  handleAtivarDesativarProjeto = () => {
    if (this.props.projeto.flgAtivo) {
      desativarProjeto(
        this.props.projeto.id,
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.successDestivarProjeto,
            options: {
              variant: 'success',
            },
          });
          this.props.refreshList();
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorDesativarProjetos,
            options: {
              variant: 'error',
            },
          });
        }
      );
    } else {
      ativarProjeto(
        this.props.projeto.id,
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.successAtivarProjeto,
            options: {
              variant: 'success',
            },
          });
          this.props.refreshList();
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorAtivarProjetos,
            options: {
              variant: 'error',
            },
          });
        }
      );
    }
  };

  showDesativarButton = () => {
    return (
      [
        'pufv_administrador',
        'pufv_cooperativa',
        'pufv_assessor_pedagogico',
        'pufv_assessor_pedagogico_gestor'
      ].includes(this.props.auth.userData.profile.perfil) && this.props.projeto.flgAtivo
    );
  };

  showAtivarButton = () => {
    return (
      this.props.auth.userData.profile.perfil === 'pufv_administrador' &&
      !this.props.projeto.flgAtivo
    );
  };

  render() {
    return (
      <Row>
        <Col cols={[12, 12, 12, 12, 12]} className={rootClassName + '-col'}>
          <div
            className={`${rootClassName} ${!this.props.projeto.flgAtivo ? rootClassName + '-inactive' : ''
              }`}
          >
            <button
              className={getMergedClassNames([
                rootClassName + '-item-button',
                this.props.auth.userPermissions.projetos.edit ||
                  this.props.auth.userPermissions.projetos.approve ||
                  this.props.auth.userPermissions.projetos.reprove
                  ? ''
                  : rootClassName + '-disabled-item-button',
              ])}
              onClick={this.openProjectNewPage}
              disabled={this.isDisabled()}
            >
              {this.props.projeto.ano} | {this.props.projeto.nome} -{' '}
              {this.props.projeto.escola}
            </button>

            <div className={rootClassName + '-status-container'}>
              {this.getAllUniqueStatus().map((status, index) => {
                return (
                  <TooltipCaller text={this.getStatusHint(status)} key={index}>
                    <button className={rootClassName + '-status-button'}>
                      <StatusIcon
                        status={status}
                        className={rootClassName + '-status-icon'}
                      />
                    </button>
                  </TooltipCaller>
                );
              })}
              {this.projetoChecked()}
              <TooltipCaller
                text={this.props.languageValues.downloadProjetoTooltip}
              >
                <DownloadProjeto
                  className={rootClassName + '-download-projeto-button'}
                  projetoId={this.props.projeto.id}
                  disabled={this.isDisabled()}
                />
              </TooltipCaller>
              {this.props.auth.userPermissions.projetos.remove ? (
                <TooltipCaller
                  text={this.props.languageValues.removerProjetoHint}
                >
                  <button
                    onClick={this.confirmRemoverProjeto}
                    className={rootClassName + '-status-button'}
                    disabled={this.isDisabled()}
                  >
                    {this.state.removing ? (
                      <RefreshIcon
                        className={getMergedClassNames([
                          rootClassName + '-loading-icon',
                        ])}
                      />
                    ) : (
                      <DeleteForeverIcon
                        className={rootClassName + '-remove-icon'}
                      />
                    )}
                  </button>
                </TooltipCaller>
              ) : null}
              {this.showDesativarButton() && (
                <TooltipCaller
                  text={this.props.languageValues.desativarProjeto}
                >
                  <button
                    className={rootClassName + '-menu-button'}
                    onClick={this.confirmAtivarDesativarProjeto}
                  >
                    <PlayListRemove fill='#e80202' />
                  </button>
                </TooltipCaller>
              )}
              {this.showAtivarButton() && (
                <TooltipCaller text={this.props.languageValues.ativarProjeto}>
                  <button
                    className={rootClassName + '-menu-button'}
                    onClick={this.confirmAtivarDesativarProjeto}
                  >
                    <PlayListAdd fill='#03a108' />
                  </button>
                </TooltipCaller>
              )}
            </div>
            {this.props.auth.userPermissions.projetos.edit ? (
              <button
                className={rootClassName + '-menu-button'}
                onClick={this.toOpenMenu}
                disabled={this.isDisabled()}
              >
                <MoreVert />
              </button>
            ) : null}
            <ProjectStepsMenu
              open={this.state.menuOpened}
              onClose={this.toCloseMenu}
              anchorEl={this.state.menuAnchor}
              avaliacoes={this.props.projeto.avaliacoes}
              idProjeto={this.props.projeto.id}
              flgNovoTemplate={this.props.projeto.flgNovoTemplate}
              flgInfantil={this.props.projeto.flgInfantil}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

ProjetoItem.propTypes = {
  projeto: PropTypes.object.isRequired,
  refreshList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
  projetos: state.projeto,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      removerProjeto,
      changeModalProps,
      closeModal,
      openModal,
      ativarProjeto,
      desativarProjeto,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProjetoItem));
